import Vue from "vue";
import { AbacoWebModule, VueRegistration } from "@abaco/web-common/src/app";
import { SensorWidgetMap } from "./models/SensorModel";
import { PinnableTile } from "@abaco/dashboard-module/src/modules/dashboard/models/Dashboard";
import IotModule from ".";

const STANDARD_PORTAL = "STANDARD_PORTAL";

export function createGlobals(
    widgetParams: SensorWidgetMap,
    pinnableTiles: PinnableTile[],
    modulesByTileID: { [key: string]: AbacoWebModule },
    module: IotModule
) {
    // Use the key in the WidgetMap as component name and id
    Object.entries(widgetParams).forEach((keyVal) => {
        const key = keyVal[0];
        const value = keyVal[1];
        // if(!ALLOWED_INDEXES.includes(key)){
        //     return;
        Vue.component(key, () => import("./components/tiles/widgets/IotCompareSensorsChart.vue"));

        pinnableTiles.push({
            module: IotModule.MODULE_ID,
            metadata: { id: key, i18nDescrKey: value.title, pinnable: true, filters: ["farm-select-nav-bar-item"] },
            tag: "STANDARD",
        });
        modulesByTileID[key] = module;
    });
}

export function deleteGlobals(widgetParams: SensorWidgetMap, pinnableTiles: PinnableTile[]) {
    Object.keys(widgetParams).forEach((key) => {
        const index = pinnableTiles.findIndex((pt) => pt.metadata.id === key);
        if (index >= 0) {
            pinnableTiles.splice(index);
        }
    });
}

export const normalGlobals: VueRegistration = {
    IotModuleContainerHome: () => import("./components/IotModuleContainerHome.vue"),
    IotDoubleTileContainerRight4on6: () => import("./components/IotDoubleTileContainerRight4on6.vue"),
    IotDoubleTileContainerRight3on6: () => import("./components/IotDoubleTileContainerRight3on6.vue"),
    IotSingleTileContainerResponsive: () => import("./components/IotSingleTileContainerResponsive.vue"),

    IotAllStationsInMapTile: () => import("./components/tiles/IotAllStationsInMapTile.vue"),
    IotAllPlotsForStationInMapTile: () => import("./components/tiles/IotAllPlotsForStationInMapTile.vue"),
    IotAllStationsTile: () => import("./components/tiles/IotAllStationsTile.vue"),
    IotConfigSectionTile: () => import("./components/tiles/IotConfigSectionTile.vue"),
    IotSensorsConfigSectionTile: () => import("./components/tiles/IotSensorsConfigSectionTile.vue"),
    IotAccountsFormTile: () => import("./components/tiles/IotAccountsFormTile.vue"),
    IotAllSensorsTile: () => import("./components/tiles/IotAllSensorsTile.vue"),
    IotAllSensorDataTile: () => import("./components/tiles/IotAllSensorDataTile.vue"),
    // "IotPlotsForStationInMapTile": () => import("./components/tiles/IotPlotsForStationInMapTile.vue"),
    IotAllPlotsForStationInListTile: () => import("./components/tiles/IotAllPlotsForStationInListTile.vue"),
    IotSensorDataHistoryChartTile: () => import("./components/tiles/IotSensorDataHistoryChartTile.vue"),
    IotSensorDataHistoryListTile: () => import("./components/tiles/IotSensorDataHistoryListTile.vue"),
    IotAddSensorPositionTile: () => import("./components/tiles/IotAddSensorPositionTile.vue"),
    IotSingleStationMapTile: () => import("./components/tiles/IotSingleStationMapTile .vue"),
    IotSensorDataHistoryMapTile: () => import("./components/tiles/IotSensorDataHistoryMapTile.vue"),
    IotCommandsDashboard: () => import("./components/tiles/IotCommandsDashboard.vue"),
    IotSensorDataHistoryImageTile: () => import("./components/tiles/IotSensorDataHistoryImageTile.vue"),
    IotPlsWaitLoginTile: () => import("./components/tiles/IotPlsWaitLoginTile.vue"),
    IotAgrirouterRegisterOnboardTile: () => import("./components/tiles/IotAgrirouterRegisterOnboardTile.vue"),

    IotStationsRecapWidget: {
        component: () => import("./components/tiles/widgets/IotStationsRecapWidget.vue"),
        meta: {
            i18nDescrKey: "iot-station-recap-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL,
        },
    },
    IotCompareSensorsChart: {
        component: () => import("./components/tiles/widgets/IotCompareSensorsChart.vue"),
        meta: {
            i18nDescrKey: "iot-sensor-data-viewer",
            filters: ["farm-select-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL,
        },
    },
    IotSensorsPositionWidget: {
        component: () => import("./components/tiles/widgets/IotSensorsPositionWidget.vue"),
        meta: {
            i18nDescrKey: "iot-sensor-position-map",
            filters: ["farm-select-nav-bar-item"],
            pinnable: true,
            tag: STANDARD_PORTAL,
        },
    },
};

// IotSensorDataViewerChart: {
//     component: () => import("./components/tiles/widgets/IotSensorDataViewerChart.vue"),
//     meta: {
//         i18nDescrKey: "iot-sensor-data-viewer",
//         filters: ["farm-select-nav-bar-item"],
//         pinnable: true,
//         tag: STANDARD_PORTAL,
//     },
// },
